/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import classnames from 'classnames';
import * as React from 'react';

import { IHeadingProps } from './Heading.props';

/**
 * Heading component.
 * @extends {React.PureComponent<IPriceProps>}
 */

const Heading = ({ headingTag: HTag = 'h1', tag: Tag, className, text, ariaLabel = text }: IHeadingProps) => (
    Tag ? <Tag aria-label={ariaLabel} className={classnames(className)}>
        {text}
    </Tag> : <HTag aria-label={ariaLabel} className={classnames(className)}>
        {text}
    </HTag>
);

export default Heading;
